import Joi from "joi";
import errorsResolver from "../schemeUtils";
import {documentTypesUser} from "../../helpers/data-constants";
import moment from "moment/moment";

const AUTHORITY_LENGTH = 100;
const DOCUMENT_NUMBER_LENGTH = 40;
const NOW_DATE = moment().utc().add(1, 'day').format('YYYY-MM-DD')

const documentAny = Joi.string()
    .required()
    .when('documentType', [
        {is: "Иной документ", then: Joi.required()},
        {is: "Идентификационная карта", then: Joi.required()},
        {is: "Паспорт", then: Joi.required()},
    ])
    .max(DOCUMENT_NUMBER_LENGTH)
    .pattern(new RegExp('^[a-zA-Z0-9]*$'))
    .error(errorsResolver({
        max: `Номер документа должен быть до ${DOCUMENT_NUMBER_LENGTH} символов`,
        required: `Номер документа обязательное поле`,
        pattern: `Номер документа содержит некорректные символы`
    }))

const dateAny = Joi.date()
    .required()
    .iso().less(NOW_DATE)
    .error(errorsResolver({
        dateLess: `Дата выдачи должна быть не ранее сегодняшнего дня`,
        dateFormat: `Некорректная дата выдачи`
    }))

const userDocumentScheme = Joi.object({
    index: Joi.any(),
    documentType: Joi.string()
        .required().valid(...documentTypesUser)
        .error(errorsResolver({
            required: `Тип документа обязательное поле`,
            values: `Тип документа обязательное поле`
        })),
    documentNumber: Joi.alternatives().conditional('documentType', {
        switch: [{
            is: "Паспорт",
            then: Joi.string()
                .required()
                .max(DOCUMENT_NUMBER_LENGTH)
                .pattern(new RegExp('^[A-Z]{2}[0-9]{7}$'))
                .error(errorsResolver({
                    max: `Номер документа должен быть до ${DOCUMENT_NUMBER_LENGTH} символов`,
                    required: `Номер документа обязательное поле`,
                    pattern: `Номер документа в неверном формате`
                }))
        }, {
            is: "Вид на жительство",
            then: Joi.string()
                .required()
                .max(DOCUMENT_NUMBER_LENGTH)
                .pattern(new RegExp('^[A-Z]{2}[0-9]{7}$'))
                .error(errorsResolver({
                    max: `Номер документа должен быть до ${DOCUMENT_NUMBER_LENGTH} символов`,
                    required: `Номер документа обязательное поле`,
                    pattern: `Номер документа в неверном формате`
                }))
        }],
        otherwise: documentAny
    }),


    startDate: Joi.alternatives().conditional('documentType', {
            switch: [{
                is: "Паспорт", then: Joi.alternatives().conditional('',
                    {
                        is: true,
                        then: Joi.date()
                            .required()
                            .iso().less(NOW_DATE)
                            .error(errorsResolver({
                                dateLess: `Дата выдачи должна быть до сегодняшнего числа`,
                                dateFormat: `Некорректная дата выдачи`
                            })),
                        otherwise: dateAny
                    })
            }, {
                is: "Вид на жительство", then: Joi.alternatives().conditional('',
                    {
                        is: true,
                        then: Joi.date()
                            .required()
                            .iso().less(NOW_DATE)
                            .error(errorsResolver({
                                dateLess: `Дата выдачи должна быть до сегодняшнего числа`,
                                dateFormat: `Некорректная дата выдачи`
                            })),
                        otherwise: dateAny
                    }),
                otherwise: dateAny
            }]
        }
    ),
    endDate: Joi.date()
        .iso()
        .required()
        .greater(Joi.ref("startDate"))
        .error(errorsResolver({
            dateFormat: `Некорректный срок действия`,
            dateGreater: `Срок действия должен быть больше даты выдачи`,
            ref: `Дата выдачи не указана`
        })),
    authority: Joi.object({
        label: Joi.string()
            .required()
            .max(AUTHORITY_LENGTH)
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.(),\\- ]{1,100}$'))
            .error(errorsResolver({
                pattern: `Место выдачи содержит некорректные символы`,
                required: `Место выдачи обязательное поле`,
                max: `Место выдачи должно быть меньше ${AUTHORITY_LENGTH} символов`
            })),
        value: Joi.number()
            .error(errorsResolver({
                number: `Должно быть число`
            }))
    })
        .invalid(null)
        .required()
        .error(errorsResolver({
            invalid: `Место выдачи обязательное поле`,
            required: `Место выдачи обязательное поле`
        })),
});


export default userDocumentScheme;
